import React, { useState } from 'react';
import { siteUrl } from "../../../utils/siteUrl";
import './nav-section-sub-menu.scss';

const NavSectionSubMenu = props => {

    var isPink = props.isPink;

    const [isLog /*setLog*/] = useState(false);
    const [isShowSexologist, setIsShowSexologist] = useState(false)
    var absoluteUrl = siteUrl + '/'
    var todoSobreNosotrasLink = siteUrl + '/entre-nosotras/'
    var magazinLink = siteUrl + '/magazin/'

    const slugRedirect = slug => {
        window.location.href = absoluteUrl + slug;
    }

    const persistRedirectTodoSobreNosotras = (slug, title) => {
        sessionStorage.setItem("slugFilter", slug)
        sessionStorage.setItem("titleFilter", title)

        window.location.href = todoSobreNosotrasLink + 'cuidado-femenino/'
    }
    const persistRedirectMagazin = (slug, title) => {
        sessionStorage.setItem("slugFilterMagazin", slug)
        sessionStorage.setItem("titleFilterMagazin", title)

        window.location.href = magazinLink + 'nuestro-mundo/'
    }

    const productRedirect = (sectionInfo, currentSectionSubMenu) => {

        // console.log('====================================');
        // console.log(sectionInfo.slug);
        // console.log(currentSectionSubMenu.slug);
        // console.log('====================================');

        window.location.href = siteUrl + '/' + currentSectionSubMenu.slug + '/' + sectionInfo.slug
    }

    const consultingRedirect = (slug) => {

        // console.log('====================================');
        // console.log(sectionInfo.slug);
        // console.log(currentSectionSubMenu.slug);
        // console.log('====================================');

        window.location.href = siteUrl + '/entre-nosotras/consultorios/' + slug
    }

    const calculateAge = () => {
        var today = new Date()
        var birthDate = new Date(
          JSON.parse(localStorage.getItem("USER_INFO")).birthdate.replace(/ /g,"T")
        )
        var age = today.getFullYear() - birthDate.getFullYear()
        var m = today.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--
        }
        return age
    }

    React.useEffect(() => {
        if (
          process.env.LOCALE === "es-CO" &&
          localStorage.getItem("TOKEN_INFO") &&
          localStorage.getItem("USER_INFO") &&
          calculateAge() >= 18
        ) {
          setIsShowSexologist(true)
        }
    }, [])

    if (!props.mobile) {
        return (
            <div className={!isPink ? "f-sub-menu f-sub-pink" : "f-sub-menu"}>

                {props.titles.map((title, index) => {

                    return (

                        <a href={absoluteUrl + title.slug} key={index}>
                            <h2 className="f-sub-menu-title" key={index}>
                                {title.titulo}
                            </h2>
                        </a>
                    )
                }
                )
                }

                <ul>

                    {props.sections && props.sections.map((section, index) => {

                        if (props.activeSubMenu === 2) {

                            if (props.identify === 0) {//Verify if is the first subMenu of Female care to persist category
                                return (
                                    <li onClick={() => persistRedirectTodoSobreNosotras(section.slug, section.titulo)} className="f-section-item" key={index}>
                                        {section.titulo}
                                    </li>
                                )

                            } else {
                                if(section.slug === 'sexologa' && !isShowSexologist){
                                    return null;
                                }
                                return (
                                    <li onClick={() => consultingRedirect(section.slug)} className="f-section-item" key={index}>
                                        {section.titulo}
                                    </li>
                                )
                            }

                        } else if (props.activeSubMenu === 3) { //Verify if is the first subMenu of products to handle subcategory

                            return (
                                <li onClick={() => productRedirect(section, props.titles[0])} className="f-section-item" key={index} >
                                    {section.titulo}
                                </li>
                            )
                        } else if (props.activeSubMenu === 5) { //Verify if is the first subMenu of our world to handle subcategory

                            return (
                                <li onClick={() => persistRedirectMagazin(section.slug, section.titulo)} className="f-section-item" key={index}>
                                    {section.titulo}
                                </li>
                            )
                        } else {

                            if (isLog) {

                                return (
                                    <li className="f-section-item" key={index}>
                                        {section.titulo}
                                    </li>
                                )
                            } else {
                                if (section.slug === 'sexologa' && !isShowSexologist) {
                                    return null
                                } else {
                                    return (
                                        <li className="f-section-item" key={index}>
                                            {section.titulo}
                                        </li>
                                    )
                                }
                            }

                        }

                    })}
                </ul>


            </div>
        )
    } else {//mobile
        return (
            <>
                {props.titles.map((title, index) => {
                    return (
                        <li onClick={evt => { slugRedirect(title.slug)/*props.sections ? props.identify === props.activeColapse ? slugRedirect(title.slug) : props.setColapse(props.identify) : slugRedirect(title.slug)*/ }} className="f-sub-menu-title-mobile" key={index}>
                            <label className="f-text-title">
                                {title.titulo}
                                {/* {props.sections !== null ? <span className={ props.identify === props.activeColapse ? "f-icon-colapse icon-right acitve-sub-colapse" : "f-icon-colapse icon-right"}></span> : null} */}
                            </label>

                            {/* <ul className="f-list-section-item-mobile">
                                {props.identify === props.activeColapse ?
                                    
                                    props.sections.map((section,index) => {
                                        if(props.activeSubMenu === 2 && props.identify === 0){ //Verify if is the first subMenu of Female care to persist category
                                            
                                            return <li onClick={e => {persistRedirectTodoSobreNosotras(section.slug,section.titulo); e.stopPropagation()}} className="f-section-item-mobile" key={index}>{section.titulo}</li>

                                        }else if(props.activeSubMenu === 3){ //Verify if is the first subMenu of products to handle subcategory
                                            return <li onClick={e => {productRedirect(section, props.titles[0]); e.stopPropagation()}} className="f-section-item-mobile" key={index}>{section.titulo}</li>
                                        }else{
                                            return <li className="f-section-item-mobile" key={index}>{section.titulo}</li>

                                        }
                                    })
                                    
                                    :
                                    null
                                }
                            </ul> */}
                        </li>
                    )
                })}
            </>
        );
    }
}

export default NavSectionSubMenu
